module.exports = __webpack_public_path__ + "img/right-mask.581b7a2a.png";